import { render, staticRenderFns } from "./recoveryFormSms.vue?vue&type=template&id=62938c37&scoped=true&"
import script from "./recoveryFormSms.vue?vue&type=script&lang=js&"
export * from "./recoveryFormSms.vue?vue&type=script&lang=js&"
import style0 from "./recoveryFormSms.vue?vue&type=style&index=0&id=62938c37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62938c37",
  null
  
)

export default component.exports